import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';

import { StoreAssignmentFilter } from 'src/graphql/generated/graphql';

export const getFilterConfig = ({ t }: { t: TFunction }) => [
  {
    id: 'store',
    size: 2,
    type: FilterItemType.Input,
    props: {
      name: 'storeNumber',
      placeholder: t('manage-restaurants.store-number'),
      fullWidth: true,
      label: t('manage-restaurants.store-number'),
    },
  },
  {
    id: 'storeAssignment',
    size: 2,
    type: FilterItemType.Multiselect,
    props: {
      multiple: true,
      limitTags: 1,
      inputProps: {
        placeholder: t('manage-restaurants.store-assignment'),
        variant: 'outlined',
        name: 'storeAssignment',
        label: t('manage-restaurants.store-assignment'),
      },
      options: [
        {
          name: 'Need attention',
          value: StoreAssignmentFilter.NeedAttention,
          options: {
            color: 'error',
          },
        },
      ],
    },
  },
];
